import { render, staticRenderFns } from "./RecordFeedbackDetail.vue?vue&type=template&id=44e98614&scoped=true"
import script from "./RecordFeedbackDetail.vue?vue&type=script&lang=js"
export * from "./RecordFeedbackDetail.vue?vue&type=script&lang=js"
import style0 from "./RecordFeedbackDetail.vue?vue&type=style&index=0&id=44e98614&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e98614",
  null
  
)

export default component.exports